import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-contact',
  templateUrl: './event-contact.component.html',
  styleUrls: ['./event-contact.component.scss']
})
export class EventContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
